import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createSectorSaga } from "src/store/sectors/saga";
import * as Yup from "yup";

const SectorCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Sector.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          ShowWeb: false,
          Content: "",
          ImageFile: "",
          ShortContent: "",
          Images: [],
          SeoTitle: "",
          SeoDescription: "",
          SeoImageFile: "",
          Translates: languages.map((x) => {
            return {
              LanguageId: x.EnumId,
              Name: "",
              Content: "",
              ShortContent: "",
              SeoTitle: "",
              SeoDescription: "",
            };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createSectorSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: { ...values, Images: [...values.Images] },
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Content: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
              Content: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Sector.Name").toString(),
          },
          {
            field: "ShortContent",
            label: t("Sector.ShortContent").toString(),
            type: "textarea",
          },
          {
            field: "Content",
            label: t("Sector.Content").toString(),
            isEditor: true,
          },
          {
            field: "SeoTitle",
            label: t("Sector.SeoTitle").toString(),
            type: "textarea",
          },
          {
            field: "SeoDescription",
            label: t("Sector.SeoDescription").toString(),
            type: "textarea",
          },
        ]}
        inputs={[
          {
            field: "ImageFile",
            label: t("Sector.ImageFile").toString(),
            type: "file",
            fileField: "ImageFileField",
            accept: "image/png, image/jpeg",
          },
          {
            field: "SeoImageFile",
            label: t("Sector.SeoImageFile").toString(),
            type: "file",
            fileField: "ImageFileField",
            accept: "image/png, image/jpeg",
          },
          {
            field: "Images",
            label: t("Sector.SliderImages").toString(),
            type: "file",
            multiple: true,
          },
          {
            field: "ShowWeb",
            label: t("Sector.ShowWeb").toString(),
            type: "switch",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default SectorCreateForm;
